import { render, staticRenderFns } from "./Biologia.vue?vue&type=template&id=7391df46&scoped=true"
import script from "./Biologia.vue?vue&type=script&lang=js"
export * from "./Biologia.vue?vue&type=script&lang=js"
import style0 from "./Biologia.vue?vue&type=style&index=0&id=7391df46&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7391df46",
  null
  
)

export default component.exports